export const BOOKIES_REQUEST = 'bookiesRequest';
export const BOOKIES_FAILURE = 'bookiesFailure';
export const BOOKIES_SUCCESS = 'bookiesSuccess';
